export default "__VITE_ASSET__CELpiBXG__"